import React from "react";
import "primeflex/primeflex.css";

export default function CardLabel({ title }) {
  return <div class="text-2xl font-bold text-indigo-900">{title}</div>;
}
